import script from "./SuccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessView.vue?vue&type=script&setup=true&lang=js"

import "./SuccessView.vue?vue&type=style&index=0&id=1733fa99&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1733fa99"]])

export default __exports__